import React from 'react';

import { SimpleMultiSelect } from '~/src/dash/components/dropdowns/SimpleMultiSelect';
import { IconToggle } from '~/src/dash/components/toggles/IconToggle';
import { Col, Cols, spacing } from '~/src/dash/publicaUI';
import { IMenuList } from '~/src/dash/types/menuList';
import { publicaColors } from '~/src/dash/utils/colors';

interface IColumnSelectorAndTableExpandProps {
  // simple multi select
  columnsList: IMenuList;
  columnsHandleOnChangeOption: (keys: string[], _id?: string) => void;
  columnsHandleOnAccept: (keys: string[]) => void;
  preselectedColumnKeys?: string[];
  resetActiveColumnKeys?: string[];
  // icon toggle
  isTableExpanded: boolean;
  setIsTableExpanded: (isActive: boolean) => void;
}

export const ColumnSelectorAndTableExpand = ({
  // simple multi select
  columnsList,
  columnsHandleOnChangeOption,
  columnsHandleOnAccept,
  preselectedColumnKeys,
  resetActiveColumnKeys,
  // icon toggle
  isTableExpanded,
  setIsTableExpanded,
}: IColumnSelectorAndTableExpandProps) => {
  return (
    <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
      {/* ACTIVE COLUMNS */}
      <Col>
        <SimpleMultiSelect
          buttonStyle={{ padding: '2px 4px 2px 12px' }}
          resetKeys={resetActiveColumnKeys}
          preselectedKeys={preselectedColumnKeys || []}
          label='Active Columns'
          list={columnsList}
          handleOnChangeOption={columnsHandleOnChangeOption}
          handleOnAccept={columnsHandleOnAccept}
          singularLabel='Active Column'
          iconPath='/assets/shared/svg/ColumnEdit.svg'
        />
      </Col>
      {/* Expand / Condense Padding */}
      <Col>
        <IconToggle
          activeBackgroundColor='inherit'
          backgroundColor='inherit'
          hoverColor={publicaColors.veryLightGray}
          imagePath='assets/shared/svg/PaddingExpand16.svg'
          imageStyle={{ height: '28px', padding: '6px' }}
          isActive={isTableExpanded}
          setIsActive={setIsTableExpanded}
          tooltipPlacement='top-end'
          tooltipText={isTableExpanded ? 'Compact Table' : 'Comfortable Table'}
        />
      </Col>
    </Cols>
  );
};
